export default __webpack_public_path__ + "static/media/FiraSans-SemiBoldItalic.58e6731e.woff";